import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import { stripNonNumeric, formatForInputField } from "@/functions/numbers";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PolygonDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix, modifierAction } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'polygon', isCutout ) );
const modifiers = computed(() => store.getters.getModifiers( isCutout ));
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const width = computed({
	get: () => formatForInputField(dimensions.value["width"]),
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const sideAmount = computed({
	get: () => formatForInputField(modifiers.value["side_amount"]),
	set: (value: string) => {
		store.commit(modifierAction, {
			modifier: "side_amount",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "polygon-width",
        id: `${_ctx.prefix}measurements-polygon-width`,
        name: `${_ctx.prefix}measurements[dimensions][width]`,
        unit: "cm",
        label: dimensionLabel.value('width', 'polygon'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}polygon-width`),
        onBlur: () => _unref(addSizeToDataLayer)('width', +width.value, 'polygon'),
        modelValue: width.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((width).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "polygon-side_amount",
        id: `${_ctx.prefix}measurements-polygon-side_amount`,
        name: `${_ctx.prefix}measurements[modifiers][side_amount]`,
        inputmode: 'numeric',
        type: 'number',
        min: 3,
        max: 30,
        step: 1,
        label: dimensionLabel.value('side_amount', 'polygon'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('side_amount'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}polygon-side_amount`),
        onBlur: () => _unref(addSizeToDataLayer)('side_amount', +sideAmount.value, 'polygon'),
        modelValue: sideAmount.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sideAmount).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})